$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import {Navigation,Pagination,Autoplay, EffectCoverflow,} from 'swiper/modules';




gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {


    // --- SHOWHIDE NAVBAR ---

    var didScroll;
    var lastScrollTop = 0;
    var delta = 120;
    var navbarHeight = 110;
    $(window).scroll(function () {
        didScroll = true;
    });
    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 350);
    function hasScrolled() {
        var st = $(this).scrollTop();
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight) {
            $('.nav-sticky').addClass('nav-up');
        } else {
            if (st + $(window).height() < $(document).height()) {
                $('.nav-sticky').removeClass('nav-up');
            }
        }
        lastScrollTop = st;
    }
    
    // --- NAV ---

    
    $(".nav-burger").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    }); 
    
    $(".nav ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });
    $(".nav-responsive ul.menu > li.menu-item-has-children > a").on("click", function(e){
    e.preventDefault();
    e.stopPropagation();
    
    var $this = $(this);
    var $parent = $this.parents("li").first();
    
    var $subMenu = $("ul.sub-menu", $parent);
    if($subMenu.is(":visible")) {
        $subMenu.hide();
    } else {
        $(".nav-active ul.menu li ul.sub-menu").hide();
        $subMenu.show();
    } 
    });
    
    $(".page-single article .gallery br").remove();  

    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    $(document.body).trigger('wc_fragment_refresh');


     

     /*-------- Swiper annimation header ---------*/

    var mySwiper = new Swiper(".mySwiper", {
        modules: [Autoplay,Navigation],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        speed: 1000,
        slidesPerView: 1,
        autoplay: {
        delay: 8000,
        },
        navigation: {
            nextEl: ".button-next",
            prevEl: ".button-prev",
          },
    });


    /*-------- CHANGE LA SRC DE L'IMAGE ---------*/
    $('.hover-img').each(function() {
        const $img = $(this);
        const src1 = $img.attr('src');
        const src2 = src1.replace('_1.svg', '_2.svg');

        $img.hover(
            function() {
                $img.attr('src', src2);
            },
            function() {
                $img.attr('src', src1);
            }
        );
    });

    /*-------- Swiper activite ---------*/
   /* var swiper = new Swiper(".activiteSwiper", {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
        initialSlide: 1, // index de la slide du milieu
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
      */


      var swiper1 = new Swiper(".activiteSwiperMain", {
        modules: [Navigation,],
        grabCursor: false,
        centeredSlides: true,
        //spaceBetween: 30,
        speed: 800,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            
            768: {
                slidesPerView: 2,
                initialSlide: 2,
            },
            1200: {
                slidesPerView: 3,
                initialSlide: 2,
            },
        
          },
      });

      var swiper2 = new Swiper(".activiteSwiperThumbs", {
        modules: [Navigation,],
        grabCursor: false,
        centeredSlides: true,
        spaceBetween: 30,
        initialSlide: 2,
        //slidesPerView: 3,
        speed: 800,
        breakpoints: {
            768: {
                slidesPerView: 2,
                initialSlide: 2,
            },
            1200: {
                slidesPerView: 3,
                initialSlide: 2,
            },
        
          },
      });

  


      swiper1.on('slideChange', () => {
        swiper2.slideTo(swiper1.activeIndex);
      });
      swiper2.on('slideChange', () => {
        swiper1.slideTo(swiper2.activeIndex);
      });







   


    

    
});

    
    

